import { useEffect, useState } from 'react';
import { debounce } from 'throttle-debounce';
import useStores from './useStores';

export const makeUseStoreHook = storeName =>
  dataSelector => useStores(stores => stores[storeName], dataSelector);

const toPascalCase = storeName =>
  `${storeName.slice(0, 1).toUpperCase()}${storeName.slice(-(storeName.length - 1))}`;

export const makeUseStoreHookName = storeName =>
  `use${toPascalCase(storeName)}`;

export const useWindowSize = () => {
  const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const getHeigth = () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

  const [windowSize, setWindowSize] = useState({
    width: getWidth(),
    heigth: getHeigth(),
  });

  useEffect(() => {
    const handleResize = debounce(100, () =>
      setWindowSize({
        width: getWidth(),
        heigth: getHeigth(),
      }));

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
};
